var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reset-password-form" }, [
    _vm.hasError
      ? _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fas fa-exclamation-triangle" }),
            _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.successMessage
      ? _c(
          "div",
          { staticClass: "alert alert-success", attrs: { role: "alert" } },
          [
            _c("i", { staticClass: "fas fa-check-circle" }),
            _vm._v("\n    " + _vm._s(_vm.successMessage) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isTokenValid
      ? _c(
          "form",
          {
            staticClass: "auth-form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.validateToken.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.token,
                    expression: "token",
                  },
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.errors.token },
                attrs: {
                  id: "token",
                  type: "text",
                  placeholder: "Enter your reset token",
                  required: "",
                  disabled: _vm.isLoading,
                },
                domProps: { value: _vm.token },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.token = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.errors.token
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.errors.token[0]) + "\n      "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-block",
                attrs: { type: "submit", disabled: _vm.isLoading },
              },
              [
                _vm.isLoading
                  ? _c("span", { staticClass: "loading-spinner" })
                  : _vm._e(),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.isLoading ? "Validating Token..." : "Validate Token"
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        )
      : _c(
          "form",
          {
            staticClass: "auth-form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.handleSubmit.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "password-input-wrapper" }, [
                (_vm.showPassword ? "text" : "password") === "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.password },
                      attrs: {
                        id: "password",
                        placeholder: "Enter your new password",
                        required: "",
                        disabled: _vm.isLoading,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.password)
                          ? _vm._i(_vm.password, null) > -1
                          : _vm.password,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.password,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.password = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.password = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.password = $$c
                          }
                        },
                      },
                    })
                  : (_vm.showPassword ? "text" : "password") === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.password },
                      attrs: {
                        id: "password",
                        placeholder: "Enter your new password",
                        required: "",
                        disabled: _vm.isLoading,
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.password, null) },
                      on: {
                        change: function ($event) {
                          _vm.password = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.password },
                      attrs: {
                        id: "password",
                        placeholder: "Enter your new password",
                        required: "",
                        disabled: _vm.isLoading,
                        type: _vm.showPassword ? "text" : "password",
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.password = $event.target.value
                        },
                      },
                    }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "password-toggle",
                    attrs: { type: "button", disabled: _vm.isLoading },
                    on: {
                      click: function ($event) {
                        _vm.showPassword = !_vm.showPassword
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: _vm.showPassword ? "fi fi-eye-slash" : "fi fi-eye",
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.errors.password
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.errors.password[0]) + "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "password-requirements" }, [
                _c(
                  "div",
                  {
                    staticClass: "requirement",
                    class: { met: _vm.passwordMeetsLength },
                  },
                  [
                    _c("i", {
                      class: _vm.passwordMeetsLength
                        ? "fi fi-check"
                        : "fi fi-circle",
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("At least 8 characters")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "requirement",
                    class: { met: _vm.passwordMeetsUppercase },
                  },
                  [
                    _c("i", {
                      class: _vm.passwordMeetsUppercase
                        ? "fi fi-check"
                        : "fi fi-circle",
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("One uppercase letter")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "requirement",
                    class: { met: _vm.passwordMeetsLowercase },
                  },
                  [
                    _c("i", {
                      class: _vm.passwordMeetsLowercase
                        ? "fi fi-check"
                        : "fi fi-circle",
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("One lowercase letter")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "requirement",
                    class: { met: _vm.passwordMeetsNumber },
                  },
                  [
                    _c("i", {
                      class: _vm.passwordMeetsNumber
                        ? "fi fi-check"
                        : "fi fi-circle",
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("One number")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "requirement",
                    class: { met: _vm.passwordMeetsSpecial },
                  },
                  [
                    _c("i", {
                      class: _vm.passwordMeetsSpecial
                        ? "fi fi-check"
                        : "fi fi-circle",
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("One special character")]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "password-input-wrapper" }, [
                (_vm.showConfirmPassword ? "text" : "password") === "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password_confirmation,
                          expression: "password_confirmation",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.password_confirmation },
                      attrs: {
                        id: "password_confirmation",
                        placeholder: "Confirm your new password",
                        required: "",
                        disabled: _vm.isLoading,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.password_confirmation)
                          ? _vm._i(_vm.password_confirmation, null) > -1
                          : _vm.password_confirmation,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.password_confirmation,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.password_confirmation = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.password_confirmation = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.password_confirmation = $$c
                          }
                        },
                      },
                    })
                  : (_vm.showConfirmPassword ? "text" : "password") === "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password_confirmation,
                          expression: "password_confirmation",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.password_confirmation },
                      attrs: {
                        id: "password_confirmation",
                        placeholder: "Confirm your new password",
                        required: "",
                        disabled: _vm.isLoading,
                        type: "radio",
                      },
                      domProps: {
                        checked: _vm._q(_vm.password_confirmation, null),
                      },
                      on: {
                        change: function ($event) {
                          _vm.password_confirmation = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password_confirmation,
                          expression: "password_confirmation",
                        },
                      ],
                      staticClass: "form-control",
                      class: { "is-invalid": _vm.errors.password_confirmation },
                      attrs: {
                        id: "password_confirmation",
                        placeholder: "Confirm your new password",
                        required: "",
                        disabled: _vm.isLoading,
                        type: _vm.showConfirmPassword ? "text" : "password",
                      },
                      domProps: { value: _vm.password_confirmation },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.password_confirmation = $event.target.value
                        },
                      },
                    }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "password-toggle",
                    attrs: { type: "button", disabled: _vm.isLoading },
                    on: {
                      click: function ($event) {
                        _vm.showConfirmPassword = !_vm.showConfirmPassword
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: _vm.showConfirmPassword
                        ? "fi fi-eye-slash"
                        : "fi fi-eye",
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.errors.password_confirmation
                ? _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.errors.password_confirmation[0]) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-block",
                attrs: { type: "submit", disabled: _vm.isLoading },
              },
              [
                _vm.isLoading
                  ? _c("span", { staticClass: "loading-spinner" })
                  : _vm._e(),
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.isLoading ? "Resetting Password..." : "Reset Password"
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        ),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "p",
        { staticClass: "signin-link" },
        [
          _vm._v("\n      Remember your password?\n      "),
          _c(
            "router-link",
            {
              staticClass: "link-primary",
              attrs: { to: `/${_vm.currentLocale}/auth/login` },
            },
            [_vm._v("\n        Sign in here\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tooltip-container" }, [
      _c("i", { staticClass: "fi fi-info-circle tooltip-icon" }),
      _vm._v(" "),
      _c("div", { staticClass: "tooltip-content" }, [
        _vm._v(
          "\n              Allowed special characters: @ $ ! % * ? & #\n            "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }